import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains } from 'ramda';

// Redux
import { connect } from 'react-redux';

import { logoutRequest } from '../../actions/session/sessionActions';
import { LOGOUT_REQUEST } from '../../actions/session/types';

import LoadingState from '../LoadingState';

import s from './Logout.css';


// Logout is independent of a redux connected LandingPage. It's like David Pumpkins, "it's own thaaaang."
export class Logout extends Component {
  static propTypes = {
    loading: object,
    logoutRequest: func,
  };

  componentDidMount() {
    this.props.logoutRequest();
  }

  render = () => {
    const isLoading = contains(LOGOUT_REQUEST, this.props.loading.requests);

    return (
      <div className={s.component}>
        {isLoading &&
          <div>
            <p className={s.message}>
              You are logging out...
            </p>
            <LoadingState />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
  logoutRequest: () => dispatch(logoutRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout/Logout.js